import axios from 'axios';

const API_URL = 'https://ni9i6kkyfd.execute-api.us-east-1.amazonaws.com/prod/affinity';

export const GetAffinityList = async (listId) => {
  try {
    const response = await axios.get(API_URL, {
      params: listId ? {
        list_id: listId
      } : {},
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}`
      },
    });

    if (response.status === 200) {
      return response.data;
    } else {
      console.error('Error:', response.status, response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
};
